import Vue from 'vue'
import VueMomentLib from 'vue-moment-lib'
Vue.use(VueMomentLib)
